import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, map } from 'rxjs';
import { CalendarBasedUliCreationFormModel } from '../../models';
import { UliCreationFacade } from './uli-creation.facade';
@Injectable({ providedIn: 'root' })
export class CalendarUliGuard {
  constructor(private uliCreationFacade: UliCreationFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.uliCreationFacade.calendarPrefillData$.pipe(
      map((_calendarPrefillData: CalendarBasedUliCreationFormModel) => {
        // TODO: Fix reload data on refresh after Prod FE (1.96.0) release
        // if (!calendarPrefillData) {
        //   const storageData = this.uliCreationService.loadUliCalendar() ?? null;
        //   console.log('storageData', storageData.timeslotStart, storageData.timeslotEnd);
        //   !!storageData ? this.uliCreationFacade.createCalendarPrefillData(storageData) : null;
        // }

        return true;
      }),
    );
  }
}
